// src/api/calendarApi.js
import apiClient from "./apiClient";

export async function getCalendarEvents() {
  const response = await apiClient.get("/api/calendar/events");
  return response.data.events;
}